import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import useRequests from '../../../Utils/useRequests';


const SupervisorDropdown = () => {
  const [menu, setMenu] = useState(false);
  const [supervisors, setSupervisors] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState({ a_id: 'all', name: 'All Organizations' });
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(true);
  const { getRequest } = useRequests();

  useEffect(() => {
    // Get user type (same as SidebarContent)
    const fetchType = async () => {
      const res = await getRequest("get-admin-info");
      if (res && res.code === 200) {
        setType(res.data.type);
      }
      setLoading(false);
    };
    fetchType();
  }, []);

  useEffect(() => {
    // Fetch supervisor list from API
    const fetchSupervisors = async () => {
      const res = await getRequest('get-organization');
      if (res && res.code === 200 && Array.isArray(res.data)) {
        setSupervisors(res.data);
        // Set default from localStorage if exists
        const stored = localStorage.getItem('SELECTED_SUPERVISOR_ID');
        if (stored) {
          if (stored === 'all') {
            setSelectedSupervisor({ a_id: 'all', name: 'All Organizations' });
          } else {
            const found = res.data.find(s => String(s.a_id) === String(stored));
            if (found) setSelectedSupervisor(found);
          }
        } else {
          setSelectedSupervisor({ a_id: 'all', name: 'All Organizations' });
          localStorage.setItem('SELECTED_SUPERVISOR_ID', 'all');
        }
      }
    };
    fetchSupervisors();
  }, []);

  const handleSelect = (supervisor) => {
    setSelectedSupervisor(supervisor);
    localStorage.setItem('SELECTED_SUPERVISOR_ID', supervisor.a_id);
    window.dispatchEvent(new CustomEvent('supervisorChanged', { detail: supervisor }));
    window.location.reload();
  };

  const toggle = () => setMenu(!menu);

  if (loading || type === "organization") {
    return null;
  }
  return (
    <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block ms-2">
      <DropdownToggle className="btn header-item supervisor-toggle" tag="button">
        <span>{
          selectedSupervisor
            ? (selectedSupervisor.organization_name || selectedSupervisor.name || 'All Organizations')
            : 'All Organizations'
        }</span>
        <i className="bx bx-chevron-down ms-2" style={{ fontSize: '18px', verticalAlign: 'middle' }}></i>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          key="all"
          onClick={() => handleSelect({ a_id: 'all', name: 'All Organizations' })}
          active={selectedSupervisor && String(selectedSupervisor.a_id) === 'all'}
        >
          All Organizations
        </DropdownItem>
        {supervisors.length === 0 && (
          <DropdownItem disabled>No organization found</DropdownItem>
        )}
        {supervisors.map(s => (
          <DropdownItem
            key={s.a_id}
            onClick={() => handleSelect(s)}
            active={selectedSupervisor && String(selectedSupervisor.a_id) === String(s.a_id)}
          >
            {s.organization_name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default withTranslation()(SupervisorDropdown);
